/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The variant of the action icon.
 */
export const ActionIconVariant = {
  Caution: "caution",
  Critical: "critical",
  Default: "default",
  Disabled: "disabled",
  Eai: "eai",
  EStop: "eStop",
  Faulted: "faulted",
  ModeCaution: "mode_caution",
  ModeConserving: "mode_conserving",
  ModeCooling: "mode_cooling",
  ModeDefault: "mode_default",
  ModeSecondary: "mode_secondary",
  ModeTertiary: "mode_tertiary",
  ModeWarning: "mode_warning",
  Off: "off",
  On: "on",
  Oos: "oos",
  Satisfied: "satisfied",
  Warning: "warning",
} as const;
/**
 * The variant of the action icon.
 */
export type ActionIconVariant = OpenEnum<typeof ActionIconVariant>;

/**
 * The config of the action icon.
 */
export type ActionIcon = {
  /**
   * The name of the icon
   */
  icon: string;
  /**
   * The variant of the action icon.
   */
  variant?: ActionIconVariant | undefined;
};

/** @internal */
export const ActionIconVariant$inboundSchema: z.ZodType<
  ActionIconVariant,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ActionIconVariant);
/** @internal */
export const ActionIconVariant$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  ActionIconVariant
> = openEnums.outboundSchema(ActionIconVariant);

/** @internal */
export const ActionIcon$inboundSchema: z.ZodType<
  ActionIcon,
  z.ZodTypeDef,
  unknown
> = z.object({
  icon: types.string(),
  variant: ActionIconVariant$inboundSchema.default("default"),
});
/** @internal */
export type ActionIcon$Outbound = {
  icon: string;
  variant: string;
};

/** @internal */
export const ActionIcon$outboundSchema: z.ZodType<
  ActionIcon$Outbound,
  z.ZodTypeDef,
  ActionIcon
> = z.object({
  icon: z.string(),
  variant: ActionIconVariant$outboundSchema.default("default"),
});

export function actionIconToJSON(actionIcon: ActionIcon): string {
  return JSON.stringify(ActionIcon$outboundSchema.parse(actionIcon));
}
export function actionIconFromJSON(
  jsonString: string,
): SafeParseResult<ActionIcon, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ActionIcon$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ActionIcon' from JSON`,
  );
}
